import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BorderPicker } from '../ColorPicker'
import WiringPanel from 'components/WiringPanel'
import { updateWiredDeviceAction, changeWiredDeviceTypeAction, deleteWiredDeviceAction, removeDeviceWiresAction } from 'actions/entityActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import { notificationAction } from 'actions/notificationActions'
import getTypeIconString from 'helpers/wiredDevices/getTypeIconString'
import { WIRED_DEVICE_TYPES, COPY_ICON_STACK } from 'helpers/globals'

const mapStateToProps = state => {
  const { entities: { wiredDevices: { byId } }, currentEntity: { id }, map: { ref } } = state

  return {
    currentWiredDevice: byId[id],
    map: ref
  }
}

const initialState = { showBorderPicker: false }

class WiredDeviceDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = { ...initialState }
  }

  setHexValue = (value, key, close = true) => {
    const { updateWiredDeviceAction, currentWiredDevice } = this.props
    updateWiredDeviceAction(currentWiredDevice.id, { [key === 'strokeColor' ? 'color' : 'fillColor']: value })

    if (close) this.setState(initialState)
  }

  toggle = key => {
    if (this.state[key]) this.setState(initialState)
    else this.setState({ ...initialState, [key]: true })
  }

  handleNameChange = ({ target: { value } }) => {
    const { currentWiredDevice: { id, nameTouched }, updateWiredDeviceAction } = this.props

    updateWiredDeviceAction(id, Object.assign({}, { name: value }, !nameTouched && { nameTouched: true }))
  }

  handleTypeChange = newType => _ => {
    const { currentWiredDevice: { id, type }, changeWiredDeviceTypeAction } = this.props

    if (type !== newType) changeWiredDeviceTypeAction(id, newType)
  }

  renderBody() {
    const { setHexValue, handleNameChange, handleTypeChange, state: { showBorderPicker }, props: { currentWiredDevice,
      highlightNetworkClosetListener, updateWiredDeviceAction, classes } } = this
    const { id, name, color, type, manufacturer, model } = currentWiredDevice

    if (showBorderPicker) return <BorderPicker cameraOnly { ...{ strokeColor: color, setHexValue, labelText: 'Color' } } />

    return (
      <div>
        <div className={classes.row}>
          <span>Name</span>
          <input
            type='text'
            className={classes.nameInput}
            onChange={handleNameChange}
            value={name || ''}
          />
        </div>
        <div className={classes.row}>
          <span>Type</span>
          <div className={classes.typesContainer}>
            { WIRED_DEVICE_TYPES.map(({ text, value }) =>
                <div
                  style={{ background: type === value ? color : 'white', color: type === value ? 'white' : color }}
                  onClick={handleTypeChange(value)}
                  className={classes.type}
                  title={text}
                  key={value}
                >
                  <FontAwesomeIcon icon={getTypeIconString(value)} style={{ margin: 'auto' }} />
                </div>
              )
            }
          </div>
        </div>
        <div className={classes.row}>
          <span style={{ width: '10rem' }}>Manufacturer</span>
          <input
            type='text'
            className={classes.nameInput}
            onChange={({ target: { value } }) => updateWiredDeviceAction(id, { manufacturer: value })}
            value={manufacturer || ''}
          />
        </div>
        <div className={classes.row}>
          <span style={{ width: '10rem' }}>Model</span>
          <input
            type='text'
            className={classes.nameInput}
            onChange={({ target: { value } }) => updateWiredDeviceAction(id, { model: value })}
            value={model || ''}
          />
        </div>
        <div className={classes.row}>
          <WiringPanel
            startDevice={currentWiredDevice}
            startDeviceType='wiredDevice'
            highlightNetworkClosetListener={highlightNetworkClosetListener}
            mobile
          />
        </div>
      </div>
    )
  }

  render() {
    const { toggle, props: { currentWiredDevice, map, updateWiredDeviceAction, removeDeviceWiresAction, deleteWiredDeviceAction,
      checkOfflineLimitsAction, notificationAction, classes } } = this

    if (!currentWiredDevice) return null

    const { id, color, location, locked, type } = currentWiredDevice

    return (
      <div className={classes.wiredDeviceDetails}>
        <div className={classes.header}>
          Edit {type}
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={_ => {
              if (locked) notificationAction(`Cannot delete locked ${type}`)
              else {
                removeDeviceWiresAction(id, 'wiredDevice')
                deleteWiredDeviceAction(id)
              }
            }}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          <div className={classes.colorButton} onClick={_ => toggle('showBorderPicker')} style={{ color: color === '#0000' ? 'white' : color }}>
            <FontAwesomeIcon icon={getTypeIconString(type)} className={classes.colorIcon} />
          </div>
          <div onClick={_ => checkOfflineLimitsAction('duplicateWiredDevice', [id])}>
            {COPY_ICON_STACK}
          </div>
          <div onClick={_ => map.panTo(location)}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateWiredDeviceAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        { this.renderBody() }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateWiredDeviceAction, changeWiredDeviceTypeAction, deleteWiredDeviceAction, removeDeviceWiresAction,
  checkOfflineLimitsAction, notificationAction })(injectSheet(style)(WiredDeviceDetails))



// WEBPACK FOOTER //
// ./src/components/BottomBar/WiredDeviceDetails/index.js